export function camelCase(value) {
  if (value) {
    let words = value.trim().split(" ");
    let sentence = [];
    for (let index = 0; index < words.length; index++) {
      const item = words[index];
      if (item) sentence.push(item[0] + item.substring(1).toLowerCase());
    }
    return sentence.join(" ");
  }
}
